import PropTypes from 'prop-types';
import classNames from 'classnames';

import { setMonth } from 'date-fns';

import { trans } from '@spotahome/soyuz/client';
import { formatDate } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';

import IconGeneric from '@spotahome/landings-common/src/components/IconGeneric';

import ContractTypesTooltip from './ContractTypesTooltip';

const getMonthName = monthNumber =>
  formatDate(setMonth(new Date(), monthNumber), 'MMM');

const ContractTypesCalendar = ({ type, size }) => {
  const generateClassesCalendarItem = classDirection => {
    const joinClasses = classNames(
      'contract-types__calendar-item',
      {
        'contract-types__calendar-medium': size === 'medium',
        'contract-types__calendar-small': size === 'small'
      },
      classDirection
    );

    return joinClasses;
  };

  const classes = classNames('contract-types__calendar', {
    'contract-types__daily': type === 'daily',
    'contract-types__fortnightly': type === 'fortnightly'
  });

  let mvIn;
  let mOut;
  let crStart;
  let crEnd;

  if (type === 'daily') {
    mvIn = '10';
    mOut = '20';
    crStart = '10';
    crEnd = '20';
  } else if (type === 'fortnightly') {
    mvIn = '20';
    mOut = '10';
    crStart = '16';
    crEnd = '15';
  } else {
    mvIn = '10';
    mOut = '20';
    crStart = '1';
    crEnd = '30';
  }

  return (
    <div className={classes}>
      <div className="contract-types__calendar-item">
        <div className="contract-types__calendar-text">{getMonthName(0)}</div>
      </div>
      <div
        className={generateClassesCalendarItem(
          'contract-types__calendar-right'
        )}
      >
        <div className="contract-types__calendar-text">
          <ContractTypesTooltip top left>
            <p className="contract-types__tooltip-title">
              {trans('contract_types.calendar.move_in')}
            </p>
            <p className="contract-types__tooltip-date">
              {mvIn} {getMonthName(1)}
            </p>
            <IconGeneric name="angle-down" />
          </ContractTypesTooltip>
          <ContractTypesTooltip bottom left dark>
            <IconGeneric name="angle-top" />
            <p className="contract-types__tooltip-date">
              {crStart} {getMonthName(1)}
            </p>
            <p className="contract-types__tooltip-title">
              {trans('contract_types.calendar.contract_start')}
            </p>
          </ContractTypesTooltip>
          {getMonthName(1)}
        </div>
      </div>
      <div className="contract-types__calendar-item--separated" />
      <div
        className={generateClassesCalendarItem('contract-types__calendar-left')}
      >
        <div className="contract-types__calendar-text">
          <ContractTypesTooltip top right>
            <p className="contract-types__tooltip-title">
              {trans('contract_types.calendar.move_out')}
            </p>
            <p className="contract-types__tooltip-date">
              {mOut} {getMonthName(10)}
            </p>
            <IconGeneric name="angle-down" />
          </ContractTypesTooltip>
          {getMonthName(10)}
        </div>
        <ContractTypesTooltip bottom right dark>
          <IconGeneric name="angle-top" />
          <p className="contract-types__tooltip-date">
            {crEnd} {getMonthName(10)}
          </p>
          <p className="contract-types__tooltip-title">
            {trans('contract_types.calendar.contract_end')}
          </p>
        </ContractTypesTooltip>
      </div>
      <div className="contract-types__calendar-item">
        <div className="contract-types__calendar-text">{getMonthName(11)}</div>
      </div>
    </div>
  );
};

ContractTypesCalendar.propTypes = {
  type: PropTypes.oneOf(['daily', 'monthly', 'fortnightly']).isRequired,
  size: PropTypes.oneOf(['medium', 'small']).isRequired
};

export default ContractTypesCalendar;
